<template>
    <v-data-table :headers="colunasValidas" :items="itemReajuste ? [itemReajuste] : []" hide-actions
                  class="az-table-list tabela-item-reajuste"
                  no-data-text="Não há itens cadastrados">

        <template slot="items" slot-scope="props" class="hover-linha">
            <tr class="linha-info">
                <td>
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
                </td>
                <td>
                    {{ props.item.unidade }}
                </td>
                <td>
                    {{ props.item.modelo }}
                </td>
                <td>
                    {{ props.item.marca }}
                </td>
                <td align="right">
                    <span v-if="props.item.quantidade">
                        {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                    </span>
                    <span v-else>&nbsp;-&nbsp;</span>
                </td>
                <td align="right" :class="tacharTextoCondicionalmente(props.item)">
                    {{props.item.valorUnitarioInicial | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                </td>
                <td align="right">
                    <campo-monetario
                            v-model="props.item.valorUnitarioReajustado"
                            @blur="salvarValor($event, props.item)"
                            placeholder="Valor"
                            :name="'valorUnitárioReajustado' + props.item.valorUnitarioReajustado"
                            :maxLength="18"
                            :precision="casasDecimais"
                            :prefix="prefix"
                            :suffix="suffix"
                            :required="true"
                            :disabled="true"
                            v-validate="'required'"
                            class="alinhar-direita input-reajuste"
                            :showClearButton="false"/>
                    <span class="mensagem-erro" v-if="props.item.valorUnitarioReajustado === null">
                        Obrigatório
                    </span>
                </td>
                <td align="right" v-if="!isCriterioJulgamentoMaiorDesconto">
                    <span v-if="props.item.valorTotal !== null">
                        <v-tooltip top v-if="totalMaiorQueNegociado">
                            <span class="red--text" slot="activator">
                                {{ props.item.valorTotal | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                            </span>
                            <span>
                                O valor precisa ser menor ou igual ao valor arrematado/negociado.
                            </span>
                        </v-tooltip>
                        <p v-else>
                            {{ props.item.valorTotal | cdCurrency(prefix, casasDecimais)}}{{suffix}}
                        </p>
                    </span>
                    <span v-else>&nbsp;-&nbsp;</span>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import CampoMonetario from '@/views/components/CampoMonetario'
export default {
    name: 'PainelItemTabela',
    components: {CampoMonetario},
    props: {
        itemReajuste:{
            type: Object,
            default: null
        },
        totalMaiorQueNegociado: {
            default: false
        },
        situacaoReajusteItem: {
            type: String,
            default: null
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        criterioJulgamento:{
            type: String
        },
        simboloCriterioJulgamento:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        }
    },
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            tamanho: null,
            colunas: [
                {
                    align: 'left',
                    text: 'Descrição',
                    sortable: false,
                    value: 'descricao',
                    width: '25%',
                    class: 'primary--text',
                },
                {
                    text: 'Unidade',
                    sortable: false,
                    width: '8%',
                    value: 'unidade',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    value: 'modelo',
                    text: 'Modelo',
                    sortable: false,
                    width: '10%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    value: 'marca',
                    text: 'Marca',
                    sortable: false,
                    width: '15%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Qtd',
                    align: 'right',
                    value: 'quantidade',
                    width: '5%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'valor',
                    text: this.isCriterioJulgamentoMaiorDesconto ?  'Desconto Inicial' : 'Valor Unit. Inicial',
                    align: 'right',
                    sortable: false,
                    width: '12%',
                    class: 'primary--text'
                },
                {
                    value: 'valorUnitarioReajustado',
                    text: this.isCriterioJulgamentoMaiorDesconto ? 'Desconto' : 'Valor Unitário',
                    sortable: false,
                    width: '13%',
                    align: 'right',
                    class: 'primary--text'
                },
                {
                    value: 'valorTotal',
                    text: 'Valor Total',
                    align: 'right',
                    width: '12%',
                    sortable: false,
                    class: 'primary--text'
                }
            ]
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    computed:{
        colunasValidas(){
            if(this.isCriterioJulgamentoMaiorDesconto)
                return this.colunas.filter(coluna => coluna.text !== 'Valor Total')
            return this.colunas
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        }
    },
    methods: {
        salvarValor(novoValor, item) {
            item.valorUnitarioReajustado = novoValor
            this.$emit('salvarItem', item)
        },
        pegarTamanho() {
            this.tamanho = .04 * window.innerWidth
        },
        tacharTextoCondicionalmente({valorUnitarioInicial, valorUnitarioReajustado}) {
            if(valorUnitarioInicial !== null && valorUnitarioInicial !== valorUnitarioReajustado)
                return 'tachado'
            return ''
        },
        formatarValorOuPercentual(valor){
            if(this.criterioJulgamento === 'MAIOR_DESCONTO')
                return `${valor}${this.simboloCriterioJulgamento}`

            return `${this.simboloCriterioJulgamento} ${valor}`
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style lang="stylus">
    .input-reajuste
        padding-top 0

    .tachado
        text-decoration line-through

    .linha-info
        border-bottom 0 !important
        border-top 1px solid rgba(0, 0, 0, .12)

    .tabela-item-reajuste
        padding 16px

        tr
            border 0

        thead tr th
            padding 5px 10px !important
            font-weight bold

        .v-datatable__expand-col
            border-bottom 1px solid #ddd
            padding-top 0 !important

    @media (max-width 720px)
        .tabela-item-reajuste
            padding 0

            td:nth-of-type(1):before
                content "Descrição:"

            td:nth-of-type(2):before
                content "Unidade:"

            td:nth-of-type(3):before
                content "Modelo:"

            td:nth-of-type(4):before
                content "Marca:"

            td:nth-of-type(5):before
                content "Quantidade:"

            td:nth-of-type(6):before
                content "Valor Unitário:"

            td:nth-of-type(7):before
                content "Reajustar Valor Unitário:"

            td:nth-of-type(8):before
                content "Valor Excedente:"

            td:nth-of-type(9):before
                content "Valor Total:"

            td:nth-of-type(5)
                text-align left

            td:nth-of-type(6)
                text-align left

            td:nth-of-type(7)
                text-align left

            td:nth-of-type(8)
                text-align left

            td:nth-of-type(9)
                text-align left
</style>